// Automazioni pronte: si sceglie una scheda e si completano uno o due campi.
// Ogni modello produce una bozza nel formato che il modulo e il server usano
// già ({ name, prefix, trigger, steps }): niente di nuovo da validare, e i
// campi da completare restano obbligatori nel modulo.

const base = contesto => ({
  name: '', connection: contesto.connection, prefix: '', enabled: false,
  cooldown_seconds: 60, daily_limit: 20,
});
const rispondiLi = campo => ({ action: 'message.send', inputs: { reply_to_trigger: true, body: `{{steps.0.${campo}}}` } });
const ogniGiorno = [0, 1, 2, 3, 4, 5, 6];
// L'avviso di una regola «Quando in casa…»: cosa è successo, e se serve com'è la casa.
const avvisoCasa = conStato => ({ action: 'home.notice', inputs: { aggiungi_stato: conStato, annuncia_su: '', istruzioni_ai: '', testo: '{{text}}' } });

export const MODELLI = [
  {
    id: 'meteo',
    titolo: 'Meteo del mattino',
    descrizione: 'Ogni mattina alle 7:30 controlla le previsioni e ti avvisa solo se è probabile che piova.',
    daCompletare: ['Scrivi la città', 'Scegli dove mandare l’avviso (per esempio la chat con te stesso)',
                   'Controlla la soglia di pioggia e prova i dati'],
    bozza: contesto => ({
      ...base(contesto), name: 'Meteo del mattino',
      trigger: { kind: 'schedule', kinds: ['schedule'], chat_ids: [], sender_ids: [],
                 schedule: { time: '07:30', tzid: 'Europe/Rome', weekdays: ogniGiorno, recovery: 'skip', grace_minutes: 60, text: '' } },
      steps: [
        { action: 'weather.forecast', inputs: { luogo: '', giorno: 0, testo: '{{text}}' } },
        { action: 'condition.check', inputs: { step: 1, field: 'probabilita_pioggia', operator: 'gte', value: 60 } },
        { action: 'message.send', inputs: { chat_id: '', body: '{{steps.0.text}}' } },
      ],
    }),
  },
  {
    id: 'agenda',
    titolo: 'Assistente calendario',
    descrizione: 'Scrivi «@agenda domani dentista alle 10» nella chat con te stesso: crea, cerca o elimina appuntamenti.',
    daCompletare: ['Controlla la parola di comando e i calendari'],
    bozza: contesto => ({
      ...base(contesto), name: 'Assistente calendario', prefix: '@agenda',
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [
        { action: 'calendar.interpret', inputs: { text: '{{text}}', calendar_ids: contesto.calendari.filter(c => c.can_edit).map(c => c.id) } },
        rispondiLi('text'),
      ],
    }),
  },
  {
    id: 'meteo-comando',
    titolo: 'Meteo su richiesta',
    descrizione: 'Scrivi «@meteo Roma domani» nella chat con te stesso e ti risponde con le previsioni.',
    daCompletare: ['Scrivi la città predefinita (vale quando il messaggio non ne dice una)'],
    bozza: contesto => ({
      ...base(contesto), name: 'Meteo su richiesta', prefix: '@meteo',
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [{ action: 'weather.forecast', inputs: { luogo: '', giorno: 0, testo: '{{text}}' } }, rispondiLi('text')],
    }),
  },
  {
    id: 'assistente-comando',
    titolo: 'Assistente @w',
    descrizione: 'Scrivi «@w che tempo fa domenica a Formentera e metti la crema solare nella spesa»: sceglie da sé i servizi giusti.',
    daCompletare: ['Controlla la parola di comando', 'Provala con l’anteprima, spuntando «Chiedi anche all’AI»'],
    bozza: contesto => ({
      ...base(contesto), name: 'Assistente', prefix: '@w', cooldown_seconds: 0,
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [{ action: 'assistant.run', inputs: { testo: '{{text}}' } }, rispondiLi('text')],
    }),
  },
  {
    id: 'spesa-comando',
    titolo: 'Lista della spesa di Alexa',
    descrizione: 'Scrivi «@spesa» e ti manda la lista numerata; «@spesa pane e latte» aggiunge, «@spesa presi 1 e 3» spunta, «@spesa fatto» chiude la spesa.',
    daCompletare: ['Controlla la parola di comando e dove puoi scriverla'],
    bozza: contesto => ({
      // Al supermercato i comandi arrivano a pochi secondi l'uno dall'altro
      // («presi 1», «presi 2»): l'attesa di un minuto li scartava.
      ...base(contesto), name: 'Lista della spesa', prefix: '@spesa', cooldown_seconds: 0,
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [{ action: 'shopping.list', inputs: { lista: '', aiuto_ai: true, testo: '{{text}}' } }, rispondiLi('text')],
    }),
  },
  {
    id: 'casa-comando',
    titolo: 'Casa: guarda e comanda',
    descrizione: 'Scrivi «@casa» per sapere com’è la casa; «@casa spegni il salotto», «@casa scena relax», «@casa di’ in cucina che è pronto», «@casa chiudi la porta» per comandarla.',
    daCompletare: ['Controlla la parola di comando e chi può usarla'],
    bozza: contesto => ({
      ...base(contesto), name: 'Casa', prefix: '@casa', cooldown_seconds: 0,
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [{ action: 'home.control', inputs: { testo: '{{text}}', aiuto_ai: true } }, rispondiLi('text')],
    }),
  },
  {
    id: 'alexa-comando',
    titolo: 'Fai parlare Alexa',
    descrizione: 'Scrivi «@alexa a tavola!» e lo annunciano tutte le Alexa di casa, o quella che scegli. Per un annuncio a orario scegli «A un orario» e scrivi la frase fissa.',
    daCompletare: ['Scegli quale Alexa (vuoto: tutte)', 'Controlla la parola di comando e chi può usarla'],
    bozza: contesto => ({
      ...base(contesto), name: 'Alexa', prefix: '@alexa', cooldown_seconds: 0,
      trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
      steps: [{ action: 'home.speak', inputs: { voce: '', frase: '', testo: '{{text}}' } }, rispondiLi('text')],
    }),
  },
  {
    id: 'casa-porta',
    titolo: 'Porta aperta senza nessuno in casa',
    descrizione: 'Se il Nuki si apre mentre nessuno è a casa, ti avvisa con com’è la casa in quel momento.',
    daCompletare: ['Scegli dove mandare l’avviso (per esempio la chat con te stesso)'],
    bozza: contesto => ({
      ...base(contesto), name: 'Porta aperta senza nessuno',
      trigger: { kind: 'home', kinds: ['home'], chat_ids: [], sender_ids: [],
                 home: { evento: 'porta', verso: 'aperta', dispositivi: [], solo_se_nessuno: true } },
      steps: [avvisoCasa(true), { action: 'message.send', inputs: { chat_id: '', body: '{{steps.0.text}}' } }],
    }),
  },
  {
    id: 'casa-movimento',
    titolo: 'Movimento nella cameretta',
    descrizione: 'Quando un sensore rileva movimento (per esempio la ArloBaby) ti avvisa, e se vuoi lo annuncia su Alexa.',
    daCompletare: ['Scegli il sensore', 'Scegli dove mandare l’avviso', 'Se serve, alza la pausa fra un avviso e l’altro'],
    bozza: contesto => ({
      ...base(contesto), name: 'Movimento cameretta', cooldown_seconds: 300,
      trigger: { kind: 'home', kinds: ['home'], chat_ids: [], sender_ids: [],
                 home: { evento: 'movimento', dispositivi: [], solo_se_nessuno: false } },
      steps: [avvisoCasa(false), { action: 'message.send', inputs: { chat_id: '', body: '{{steps.0.text}}' } }],
    }),
  },
  {
    id: 'casa-batterie',
    titolo: 'Batterie scariche',
    descrizione: 'Quando una batteria di casa (il Nuki, il telecomando Hue…) scende sotto il 20%, te lo dice.',
    daCompletare: ['Scegli dove mandare l’avviso'],
    bozza: contesto => ({
      ...base(contesto), name: 'Batterie scariche',
      trigger: { kind: 'home', kinds: ['home'], chat_ids: [], sender_ids: [],
                 home: { evento: 'batteria', soglia: 20, dispositivi: [], solo_se_nessuno: false } },
      steps: [avvisoCasa(false), { action: 'message.send', inputs: { chat_id: '', body: '{{steps.0.text}}' } }],
    }),
  },
  {
    id: 'casa-pulsante',
    titolo: 'Pulsante Hue: «A tavola!»',
    descrizione: 'Tieni premuto un pulsante del telecomando Hue e tutte le Alexa annunciano «A tavola!».',
    daCompletare: ['Scegli il pulsante', 'Cambia la frase o l’Alexa se vuoi'],
    bozza: contesto => ({
      ...base(contesto), name: 'A tavola', cooldown_seconds: 30,
      trigger: { kind: 'home', kinds: ['home'], chat_ids: [], sender_ids: [],
                 home: { evento: 'pulsante', pressione: 'lunga', dispositivi: [], solo_se_nessuno: false } },
      steps: [{ action: 'home.speak', inputs: { voce: '', frase: 'A tavola!', testo: '{{text}}' } }],
    }),
  },
  {
    id: 'servizio',
    titolo: 'Chiedi a un servizio',
    descrizione: 'Scrivi «@cambio USD» e ti risponde il servizio scelto: cambi, Wikipedia o uno tuo. Per il meteo c’è il modello apposito.',
    daCompletare: ['Scegli il servizio (si collegano nel menu Servizi)'],
    bozza: (contesto, extra = {}) => {
      const servizio = contesto.servizi.find(s => s.id === extra.servizio);
      const parola = extra.parola || (servizio ? `@${servizio.name.toLowerCase().replace(/[^a-z0-9]/g, '').slice(0, 20) || 'servizio'}` : '@servizio');
      return {
        ...base(contesto), name: servizio ? servizio.name : 'Chiedi a un servizio', prefix: parola,
        trigger: { kind: 'self', kinds: ['self'], chat_ids: [], sender_ids: [] },
        steps: [{ action: 'http.call', inputs: { service: servizio?.id ?? null, text: '{{text}}' } }, rispondiLi('text')],
      };
    },
  },
  {
    id: 'riassunto',
    titolo: 'Riassunto serale di una chat',
    descrizione: 'Ogni sera alle 21 l’AI riassume un gruppo e ti manda il riassunto.',
    daCompletare: ['Scegli la chat da riassumere', 'Scegli dove mandare il riassunto (per esempio la chat con te stesso)'],
    bozza: contesto => ({
      ...base(contesto), name: 'Riassunto serale',
      trigger: { kind: 'schedule', kinds: ['schedule'], chat_ids: [], sender_ids: [],
                 schedule: { time: '21:00', tzid: 'Europe/Rome', weekdays: ogniGiorno, recovery: 'skip', grace_minutes: 60, text: '' } },
      steps: [
        { action: 'chat.summarize', inputs: { chat_id: '', hours: 24, prompt: 'Riassumi argomenti, decisioni e cose da fare nella chat.' } },
        { action: 'message.send', inputs: { chat_id: '', body: '{{steps.0.text}}' } },
      ],
    }),
  },
  {
    id: 'parole',
    titolo: 'Risposta a parole chiave',
    descrizione: 'Quando qualcuno scrive una parola (es. «prezzi») l’AI risponde nella stessa chat.',
    daCompletare: ['Scegli le chat o spunta «tutte le conversazioni»', 'Scrivi le parole da cercare', 'Scrivi le istruzioni per la risposta'],
    bozza: contesto => ({
      ...base(contesto), name: 'Risposta a parole chiave',
      trigger: { kind: 'incoming', kinds: ['incoming'], chat_ids: [], sender_ids: [], senders_mode: 'anyone', match: 'anywhere', keywords: [] },
      steps: [
        { action: 'ai.respond', inputs: { text: '{{text}}', prompt: 'Rispondi in modo cortese e breve alla domanda ricevuta.' } },
        rispondiLi('text'),
      ],
    }),
  },
  {
    id: 'gruppo',
    titolo: 'Messaggio programmato a un gruppo',
    descrizione: 'Ogni lunedì alle 9 manda lo stesso messaggio, in privato, ai membri di un gruppo della rubrica.',
    daCompletare: ['Scegli il gruppo della rubrica', 'Scrivi il messaggio'],
    bozza: contesto => ({
      ...base(contesto), name: 'Messaggio del lunedì',
      trigger: { kind: 'schedule', kinds: ['schedule'], chat_ids: [], sender_ids: [],
                 schedule: { time: '09:00', tzid: 'Europe/Rome', weekdays: [0], recovery: 'skip', grace_minutes: 60, text: '' } },
      steps: [{ action: 'message.send_group', inputs: { group_id: null, body: '' } }],
    }),
  },
  {
    id: 'risposta-ai',
    titolo: 'Risposta AI in una chat',
    descrizione: 'Chi ti scrive in una chat scelta riceve una risposta scritta dall’AI con le tue istruzioni.',
    daCompletare: ['Scegli la chat', 'Scrivi le istruzioni per la risposta'],
    bozza: contesto => ({
      ...base(contesto), name: 'Risposta AI',
      trigger: { kind: 'incoming', kinds: ['incoming'], chat_ids: [], sender_ids: [], senders_mode: 'anyone' },
      steps: [
        { action: 'ai.respond', inputs: { text: '{{text}}', prompt: 'Rispondi a nome mio, in modo cortese e breve.' } },
        rispondiLi('text'),
      ],
    }),
  },
];

export const ESEMPI_AI = [
  'Ogni sera alle 21 riassumi il gruppo della scuola e mandamelo',
  'Quando scrivo @spesa mandami la lista della spesa di Alexa',
  'Avvisami se si apre la porta quando non c’è nessuno in casa',
  'Se nel gruppo calcetto qualcuno chiede «chi c’è?» rispondi con gli appuntamenti di giovedì',
];

// Una regola esistente come punto di partenza: si adatta e si salva come
// nuova, invece di rifare tutto a mano (e sbagliare qualcosa). Nasce spenta,
// e la parola di comando si svuota perché due regole non possono averla uguale.
const SOLO_DEL_SERVER = ['id', 'version', 'updated_at', 'next_run_at', 'last_scheduled_at', 'schedule_status', 'next_occurrences', 'ultima_esecuzione'];
export function copiaRegola(regola) {
  const copia = JSON.parse(JSON.stringify(regola));
  SOLO_DEL_SERVER.forEach(campo => { delete copia[campo]; });
  return { ...copia, name: `${regola.name} (copia)`, enabled: false, prefix: '' };
}

export function daCompletareInCopia(regola) {
  return [
    'Cambia il nome',
    regola.prefix ? `Scegli una parola di comando nuova (l’originale usa «${regola.prefix}»)` : null,
    regola.trigger?.chat_ids?.length || regola.trigger?.sender_ids?.length ? 'Scegli le chat e i mittenti giusti' : null,
  ].filter(Boolean);
}

